import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { ListNavigationModule, SpinnerModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { KnBrInvoiceListSeachResultComponent } from './kn-br-invoice-list-seach-result.component';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        SpinnerModule,
        RouterModule,
        NgSelectModule,
        ListNavigationModule,
        I18nModule,
        KnBrCustomPipesModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrInvoiceSearchResultComponent: {
                    component: () => import('./kn-br-invoice-list-seach-result.component').then((c) => c.KnBrInvoiceListSeachResultComponent),
                },
            },
        } as CmsConfig),
        KnBrInvoiceListSeachResultComponent,
    ],
})
export class KnBrInvoiceListSearchResultModule {}
